import { Flex, Typography } from '@iheartjane/reefer';

import { useKioskSpacing } from '../../../../hooks';

/**
 * Pinned modal header for the agreement steps. Stays put while a long set of
 * terms scrolls underneath it.
 */
export const AgreementsModalHeader = () => {
  const { getKioskSpacing } = useKioskSpacing();

  return (
    <Flex
      flexDirection="column"
      gap={getKioskSpacing(24, 16)}
      px={getKioskSpacing(32, 40)}
      pt={getKioskSpacing(32, 40)}
      shrink={false}
    >
      <Typography as="h1" branded variant="h2-semibold">
        Checkout
      </Typography>
      <Typography as="h2" textAlign="center" variant="h3-semibold">
        Store Terms &amp; Policies
      </Typography>
    </Flex>
  );
};
